import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { hostListQueries } from '@/services/hostManagement/hostManagement.queries';
import { useParams } from '@tanstack/react-router';

export const useHostDetails = () => {
  const params = useParams({ strict: false });

  const clubId = params.clubid;
  const hostCode = params['manage-host'];

  const isEdit = Boolean(clubId && hostCode);
  const { data, isLoading, isFetching } = useQuery({
    ...hostListQueries.detail(clubId, hostCode),
    enabled: isEdit,
  });

  const hostData = data?.data;
  const hostDetails = Array.isArray(hostData) ? hostData[0] : hostData;

  return {
    hostDetails,
    isLoading,
    isEdit,
    isFetching,
  };
};
